'use strict';

module.exports = {
  CHANGE_EVENT: 'changed',
  FETCH_CHANGE_EVENT: 'fetch-changed'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/marty-lib/modules/store/storeEvents.js
// module id = WQsS
// module chunks = 88